import React from "react";
import { TextField, MenuItem } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  menuItem: {
    "&.Mui-selected": {
      backgroundColor: "#D6E4FF !important", // Light blue for selected item
      color: "#003A8C !important", // Blue for selected item text
    },
    "&.Mui-selected:hover": {
      backgroundColor: "#ADCFFF !important", // Slightly darker blue on hover
    },
    "&:hover": {
      backgroundColor: "#F0F4FF", // Hover effect for non-selected items
    },
  },
}));

export default function TextFieldSelect({
  height = "40px",
  width = "100%",
  backgroundColor = "#ffffff",
  placeholder = "Select an option",
  label = "",
  value = "",
  required = false,
  readOnly = false,
  disabled = false,
  shrink = false,
  inputTextColor = "#707EAE",
  helperText = "",
  listItems = [],
  keyValue = "id",
  displayValue = "name",
  handleChange,
  name,
}) {
  const classes = useStyles();

  return (
    <TextField
      sx={{
        "& .MuiOutlinedInput-root": {
          height: `${height} !important`,
          "& .MuiSelect-select": {
            color: value ? "#003A8C" : "#B0B0B0", // Blue for selected, gray for placeholder
            fontSize: value ? "14px" : "16px", // Smaller font when value is selected
          },
        },
        "& .MuiFormLabel-root": {
          fontSize: "14px", // Label font size
          color: "#B0B0B0", // Gray label by default
        },
        "& .MuiFormLabel-root.Mui-focused": {
          color: "#003A8C", // Blue label color on focus
        },
      }}
      select
      required={required}
      variant="outlined"
      style={{
        width,
        backgroundColor,
      }}
      label={label}
      name={name}
      value={value}
      placeholder={placeholder}
      helperText={helperText}
      onChange={handleChange}
      InputLabelProps={{
        shrink: shrink || Boolean(value), // Control shrink to behave like a placeholder
        style: {
          color: value ? "#707EAE" : "#B0B0B0", // Placeholder color
        },
      }}
      InputProps={{
        readOnly,
        style: {
          color: value ? inputTextColor : "#B0B0B0",
          fontSize: "14px",
          background: "#fff",
        },
      }}
      SelectProps={{
        displayEmpty: true, // Ensure the placeholder appears in the field
        disabled,
      }}
      disabled={disabled}
    >
      <MenuItem disabled value="">
        {placeholder}
      </MenuItem>
      {Array.isArray(listItems) &&
        listItems.map((option, index) => (
          <MenuItem
            key={index}
            value={option[keyValue]}
            className={classes.menuItem}
          >
            {option[displayValue]}
          </MenuItem>
        ))}
    </TextField>
  );
}
